import { ITableData } from "../components/table/interfaces";

export const trimChartToWindow = <T extends { date: string }>(items: T[], startTs: string): T[] => {
  const startMs = new Date(startTs).getTime();
  return items.filter(it => new Date(it.date).getTime() >= startMs);
};

export const trimTableToWindow = (table: ITableData | null, startTs: string): ITableData | null => {
  if (!table || !table.rows?.length) return null;
  let i = 0;
  while (i < table.rows.length && table.rows[i] < startTs) i++;
  if (i >= table.rows.length) return null;
  const rows = i > 0 ? table.rows.slice(i) : [...table.rows];
  const items = table.items
    .map(it => ({ ...it, values: it.values.slice(i) }))
    .filter(it => it.values.some(v => v !== null));
  return items.length ? ({ type: table.type, rows, items } as ITableData) : null;
};
